import LoginModule from '../../login/index.module'

const Login = () => {
  return <LoginModule />
}

export default Login
